export default __webpack_public_path__ + "static/media/rocket_anim_156.32c071e5.png";